import { motion } from "framer-motion";
import { RYAN_STORY } from "../content";

export default function WhyBuilding() {
  return (
    <section data-testid="why-building-section" className="py-28 md:py-36 px-4 sm:px-6 max-w-6xl mx-auto border-t border-border">
      <div className="grid lg:grid-cols-[1fr_340px] gap-14 lg:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-[680px]"
        >
          <p className="font-mono text-xs tracking-[0.35em] text-gold mb-6">02 — FROM RYAN</p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-12">
            {RYAN_STORY.heading}
          </h2>
          <div className="space-y-8" data-testid="ryan-story">
            {RYAN_STORY.paragraphs.map((p, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="font-serif font-light text-lg md:text-xl leading-[1.85] text-bone/85"
              >
                {p}
              </motion.p>
            ))}
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="mt-12 font-serif italic text-2xl text-gold font-light"
            data-testid="founder-signature"
          >
            {RYAN_STORY.signature}
          </motion.p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.33, 1, 0.68, 1] }}
          className="relative lg:sticky lg:top-28 max-w-sm mx-auto lg:mx-0 w-full"
        >
          <div className="absolute -inset-3 border border-gold/20 pointer-events-none" aria-hidden="true" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/10 to-transparent blur-2xl pointer-events-none" aria-hidden="true" />
          <img
            src={RYAN_STORY.photo}
            alt={RYAN_STORY.photoAlt}
            data-testid="founder-portrait"
            className="relative w-full aspect-[4/5] object-cover object-top grayscale contrast-125 opacity-90"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
}
